import { keyManageConstants } from "../_constants";

export function keyList(state = {}, action) {
  switch (action.type) {
    case keyManageConstants.GET_ALL_KEYS_REQUEST:
      return {
        loading: true,
      };
    case keyManageConstants.GET_ALL_KEYS_SUCCESS:
      return {
        item: action.keyList,
      };
    case keyManageConstants.GET_ALL_KEYS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function keyTopInfo(state = {}, action) {
  switch (action.type) {
    case keyManageConstants.GET_KEY_TOP_INFO_REQUEST:
      return {
        loading: true,
      };
    case keyManageConstants.GET_KEY_TOP_INFO_SUCCESS:
      return {
        item: action.keyTopInfo,
      };
    case keyManageConstants.GET_KEY_TOP_INFO_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function keyCreated(state = {}, action) {
  switch (action.type) {
    case keyManageConstants.CREATE_KEY_REQUEST:
      return {
        loading: true,
      };
    case keyManageConstants.CREATE_KEY_SUCCESS:
      return {
        item: action.keyCreated,
      };
    case keyManageConstants.CREATE_KEY_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function openAPIList(state = {}, action) {
  switch (action.type) {
    case keyManageConstants.GET_ALL_OPEN_API_REQUEST:
      return {
        loading: true,
      };
    case keyManageConstants.GET_ALL_OPEN_API_SUCCESS:
      return {
        item: action.data,
      };
    case keyManageConstants.CREATE_KEY_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function userOpenAPI(state = {}, action) {
  switch (action.type) {
    case keyManageConstants.GET_USER_OPEN_API_REQUEST:
      return {
        loading: true,
      };
    case keyManageConstants.GET_USER_OPEN_API_SUCCESS:
      return {
        item: action.data,
      };
    case keyManageConstants.GET_USER_OPEN_API_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function keyDetails(state = {}, action) {
  switch (action.type) {
    case keyManageConstants.GET_KEY_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case keyManageConstants.GET_KEY_DETAILS_SUCCESS:
      return {
        item: action.keyDetails,
      };
    case keyManageConstants.GET_KEY_DETAILS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function apiAssigned(state = {}, action) {
  switch (action.type) {
    case keyManageConstants.ASSIGN_API_REQUEST:
      return {
        loading: true,
      };
    case keyManageConstants.ASSIGN_API_SUCCESS:
      return {
        item: action.apiAssigned,
      };
    case keyManageConstants.ASSIGN_API_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
export function keyFilterList(state = {}, action) {
  switch (action.type) {
    case keyManageConstants.APPLY_API_KEY_FILTER_REQUEST:
      return {
        loading: true,
      };
    case keyManageConstants.APPLY_API_KEY_FILTER_SUCCESS:
      return {
        item: action.keyFilterList,
      };
    case keyManageConstants.APPLY_API_KEY_FILTER_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
//apiKeyFilters
export function apiKeyFilters(state = {}, action) {
  switch (action.type) {
    case keyManageConstants.GET_API_KEY_FILTERS_REQUEST:
      return {
        loading: true,
      };
    case keyManageConstants.GET_API_KEY_FILTERS_SUCCESS:
      return {
        item: action.apiKeyFilters,
      };
    case keyManageConstants.APPLY_API_KEY_FILTER_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

// Activate API Key
export function activateApi(state = {}, action) {
  switch (action.type) {
    case keyManageConstants.ACTIVATE_API_KEY_REQUEST:
      return {
        loading: true,
      };
    case keyManageConstants.ACTIVATE_API_KEY_SUCCESS:
      return {
        item: action.activateApi,
      };
    case keyManageConstants.ACTIVATE_API_KEY_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
//Delete API Key

export function deleteApiKey(state = {}, action) {
  switch (action.type) {
    case keyManageConstants.DELETE_APIKEY_REQUEST:
      return {
        loading: true,
      };
    case keyManageConstants.DELETE_APIKEY_SUCCESS:
      return {
        item: action.data,
      };
    case keyManageConstants.DELETE_APIKEY_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

// update API key

export function updateApiKey(state = {}, action) {
  switch (action.type) {
    case keyManageConstants.UPDATE_API_KEY_REQUEST:
      return {
        loading: true,
      };
    case keyManageConstants.UPDATE_API_KEY_SUCCESS:
      return {
        item: action.updatedAPI,
      };
    case keyManageConstants.UPDATE_API_KEY_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
